// src/pages/LoginPage.jsx
// Why changes: ensure popup/toast shows on all outcomes (success, API error, network error). Add proper form submit, try/catch, and .catch for promises.

import React, { useEffect, useState, useCallback } from 'react';
import { Password } from '../constant';
import { useNavigate } from 'react-router-dom';
import API from '../services/API';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const LoginPage = () => {
    const navigate = useNavigate();
    const [state, setState] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);

    const getToken = useCallback(async () => {
        try {
            const jwt_token = localStorage.getItem('token');
            if (!jwt_token) return;
            const headers = {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                token: jwt_token,
            };
            const response = await API.get('/schoolStaff/checkToken', { headers });
            if (response?.data?.response_code === 1000) {
                navigate('/dashboard');
            }
        } catch (err) {
            // Why: avoid silent failures
            console.error('checkToken error:', err);
        }
    }, [navigate]);

    useEffect(() => {
        getToken();
    }, [getToken]);

    const onChange = (field, event) => {
        const value = event.target.value;
        setState(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async e => {
        e?.preventDefault();
        if (loading) return;

        if (!state.email || !state.password) {
            toast?.error?.('Sila masukkan emel dan kata laluan.', { autoClose: 4000 });
            return;
        }

        setLoading(true);
        try {
            const response = await API.post('/schoolStaff/login', {
                email: state.email,
                password: state.password,
            });
            const { data } = response || {};

            if (data?.response_code === 1000) {
                localStorage.setItem('token', data?.data?.token || '');
                localStorage.setItem('full_name', data?.data?.full_name || '');
                localStorage.setItem('school_name', data?.data?.school_name || '');
                localStorage.setItem('role', data?.data?.role || '');
                toast?.success?.('Berjaya log masuk.', { autoClose: 1500 });
                navigate('/dashboard');
            } else if (data?.response_code === 2000) {
                toast?.error?.(data?.message || 'Log masuk gagal.', { autoClose: 5000 });
            } else {
                toast?.error?.(data?.message || 'Terjadi ralat yang tidak dijangka.', { autoClose: 5000 });
            }
        } catch (err) {
            // Why: show network errors; previously there was no .catch
            const msg = err?.response?.data?.message || err?.message || 'Tidak dapat menghubungi pelayan.';
            toast?.error?.(msg, { autoClose: 5000 });
        } finally {
            setLoading(false);
        }
    };

    const handleKeyDown = e => {
        if (e.key === 'Enter') handleSubmit();
    };

    return (
        <div>
            <div className="page-wrapper">
                <div className="container-fluid p-0">
                    {/* login page start */}

                    <div className="authentication-main">
                        <div className="row">
                            <div className="col-md-12 bg-white">
                                <div className="auth-innerright">
                                    <div className="authentication-box">
                                        <div className="text-center">
                                            <img src={"https://imgur.com/kEzgWVd.png"} alt="logo" height={150} />
                                            <h2>Jaringan Keselamatan Anak Anda</h2>
                                        </div>
                                        <div className="card mt-4">
                                            <div className="card-body">
                                                <div className="text-center">
                                                    <h4>Login School Portal</h4>
                                                    <h6>Enter your Username and Password</h6>
                                                </div>
                                                <form className="theme-form" onSubmit={handleSubmit}>
                                                    <div className="form-group">
                                                        <label className="col-form-label pt-0" htmlFor="email">Email</label>
                                                        <input
                                                            id="email"
                                                            className="form-control"
                                                            type="email"
                                                            value={state.email}
                                                            onChange={e => onChange('email', e)}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="col-form-label" htmlFor="password">{Password}</label>
                                                        <input
                                                            id="password"
                                                            className="form-control"
                                                            type="password"
                                                            value={state.password}
                                                            onChange={e => onChange('password', e)}
                                                            onKeyDown={handleKeyDown}
                                                        />
                                                    </div>
                                                    <div className="form-group form-row mt-3 mb-0 d-grid">
                                                        <button
                                                            className="btn"
                                                            style={{ backgroundColor: '#E94057', color: 'white', fontWeight: 'bold' }}
                                                            type="submit"
                                                            disabled={loading}
                                                        >
                                                            {loading ? 'LOGGING IN…' : 'LOGIN'}
                                                        </button>
                                                    </div>
                                                </form>

                                                <div className="form-group mt-2 text-end">
                                                    <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        style={{ color: '#E94057', textDecoration: 'none', fontWeight: '500' }}
                                                        onClick={() => navigate('/forgot-password')}
                                                    >
                                                        Forgot password?
                                                    </button>
                                                </div>

                                                <ToastContainer
                                                    position="top-right"
                                                    autoClose={4000}
                                                    newestOnTop
                                                    closeOnClick
                                                    pauseOnHover
                                                    draggable
                                                    theme="colored"   // ✅ options: "light" | "dark" | "colored"
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
